import { languageBase } from "./i18n";
import { useEffect } from "react";
import { BrowserRouter, MemoryRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/PrintHome";
import ProductPage from "./pages/ProductPage";
import CatalogProductPage from "./pages/CatalogProductPage";
import ServicePage from "./pages/ServicePage";
import "./print-home.css";
import PageMetadata from "./components/PageMetadata";
import ChristmasPage from "./pages/ChristmasPage";
import NotFound from "./pages/NotFound";

function ScrollToHashOrTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(
          () =>
            el.scrollIntoView({
              behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
                .matches
                ? "auto"
                : "smooth",
              block: "start",
            }),
          50,
        );
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App({ initialPath }) {
  const Router = initialPath ? MemoryRouter : BrowserRouter;
  return (
    <Router basename={languageBase || undefined} initialEntries={initialPath ? [languageBase + initialPath] : undefined}>
      <PageMetadata />
      <ScrollToHashOrTop />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #0a0a0a",
            background: "#ffffff",
            color: "#0a0a0a",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/proposte/natale-2026/" element={<ChristmasPage />} />
        <Route path="/prodotti/:slug" element={<ProductPage />} />
        <Route path="/catalogo/:id" element={<CatalogProductPage />} />
        <Route path="/servizi/:slug" element={<ServicePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
